import type { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const CARD_SURFACE_CLASS =
  'bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700';

interface CardProps {
  title?: string;
  icon?: IconDefinition;
  /** Right-aligned slot in the card header (filters, buttons, ...). */
  actions?: ReactNode;
  /** Adds the standard inner padding to the body. Turn off for tables and lists. */
  padded?: boolean;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
}

export default function Card({
  title,
  icon,
  actions,
  padded = true,
  className = '',
  bodyClassName = '',
  children,
}: CardProps) {
  const hasHeader = title !== undefined || actions !== undefined;

  return (
    <div className={`${CARD_SURFACE_CLASS} ${className}`}>
      {hasHeader && (
        <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2 min-w-0">
            {icon !== undefined && <FontAwesomeIcon icon={icon} className="w-5 h-5 text-blue-600 dark:text-blue-400 shrink-0" />}
            <span className="truncate">{title}</span>
          </h2>
          {actions !== undefined && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={`${padded ? 'p-4' : ''} ${bodyClassName}`}>{children}</div>
    </div>
  );
}
